import React from 'react';

interface IProps {
  label: string;
  className?: string;
  testId: string;
}
export const SmallLabel = ({ label, className, testId }: IProps) => <div className={`font-metricR text-bw07 text-[12px] ${className || ''}`} data-testid={testId}>{label}</div>;
